import log from 'loglevel'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type applyPluginCallback = (logger: log.Logger, options?: any) => void

const trace = (...args: Parameters<typeof log.trace>) => {
  log.trace(...args)
}

const debug = (...args: Parameters<typeof log.debug>) => {
  log.debug(...args)
}

const info = (...args: Parameters<typeof log.info>) => {
  log.info(...args)
}

const warn = (...args: Parameters<typeof log.warn>) => {
  log.warn(...args)
}

const error = (...args: Parameters<typeof log.error>) => {
  log.error(...args)
}

const setLogLevel = (logLevel: string) => {
  if (log.levels[logLevel as keyof typeof log.levels] !== undefined) {
    log.setLevel(logLevel as log.LogLevelDesc)
  }
}

const getChild = (...args: Parameters<typeof log.getLogger>) => {
  return log.getLogger(...args)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const registerPlugin = (apply: applyPluginCallback, options?: any) => {
  apply(log, options)
  log.rebuild()
}

// Set some defaults
// Set debug as default level so we don't miss logs on boot
log.setLevel(log.levels.DEBUG)

export default {
  info,
  error,
  warn,
  debug,
  setLogLevel,
  getChild,
  registerPlugin,
  trace
}
